import { render, staticRenderFns } from "./ScreenTransvaginalUteroParaAvaliacaoDeReservaOvariana.vue?vue&type=template&id=e6bfd456&scoped=true&"
import script from "./ScreenTransvaginalUteroParaAvaliacaoDeReservaOvariana.vue?vue&type=script&lang=js&"
export * from "./ScreenTransvaginalUteroParaAvaliacaoDeReservaOvariana.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTransvaginalUteroParaAvaliacaoDeReservaOvariana.vue?vue&type=style&index=0&id=e6bfd456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bfd456",
  null
  
)

export default component.exports